<div class="placeholder-container">
    <p class="placeholder-text">{{ 'permit.placeholder.coming_soon' | translate }}</p>
</div>
